import {UnstyledButton as MantineUnstyledButton} from '@mantine/core';

/**
 * Unstyled button base for custom clickable surfaces — design-layer pass-through over Mantine `UnstyledButton`.
 * @registry Pass-through Mantine UnstyledButton; import this instead of @mantine/core outside src/design.
 */
export const UnstyledButton = MantineUnstyledButton;
